import React, { useState, useCallback } from 'react';
import { TextField, LoadingSpinner, Icon } from '@doxyme/ui';
import './password.scss';
export const PasswordField = React.forwardRef((props, ref) => {
    const [type, setType] = useState('password');
    const { loading, ...restProps } = props;
    const btn = (<>
        {loading && <LoadingSpinner className="password-spinner" size="small"/>}
        <button tabIndex={-1} className="password-button" type="button" onClick={() => setType(type === 'password' ? 'text' : 'password')}>
          {type === 'password' ? <Icon name="password-hide" size="x-small"/> : <Icon name="password-show" size="x-small"/>}
        </button>
      </>);
    const handleClipboardEvent = useCallback((e) => {
        if (type === 'password') {
            e.preventDefault();
        }
    }, [type]);
    return (<TextField ref={ref} {...restProps} type={type} endAdornment={btn} autoComplete="off" onCopy={handleClipboardEvent}/>);
});
